/**
 * Black Friday Header Styling
 * Aplica estilos de tema escuro no header quando na página /collections/black
 */

(function() {
  'use strict';

  // Verifica se estamos na página da coleção blac
  const isBlackCollection = document.body.classList.contains('collection-handle-black');
    console.log('inicio da black friday', !isBlackCollection)
  
  if (!isBlackCollection) {
    return; // Não faz nada se não estiver na página black
  }

  console.log('🖤 Black Friday theme detected - Applying dark header styles...');

  // Adiciona classe adicional para facilitar o targeting CSS
  const headerElement = document.querySelector('.section-header') || 
                        document.querySelector('[class*="shopify-section"][class*="header"]');
  
  if (headerElement) {
    headerElement.classList.add('black-friday-theme');
    console.log('✅ Added black-friday-theme class to header');
  }

  // Força a cor branca em todos os ícones SVG do header
  function updateSVGColors() {
    // Seleciona todos os SVGs no header (usando múltiplos seletores)
    const headerSVGs = document.querySelectorAll(
      '.section-header svg, ' +
      '[class*="shopify-section"][class*="header"] svg, ' +
      '.pageheader svg, ' +
      '.logo-area svg'
    );
    
    headerSVGs.forEach(svg => {
      // Força stroke branco
      svg.style.stroke = '#ffffff';
      svg.style.color = '#ffffff';
      
      // Para paths dentro dos SVGs
      const paths = svg.querySelectorAll('path, line, polyline, circle, g');
      paths.forEach(path => {
        path.style.stroke = '#ffffff';
        
        // Mantém fill apenas se for explícito
        const fillAttr = path.getAttribute('fill');
        if (fillAttr && fillAttr !== 'none') {
          path.style.fill = '#ffffff';
        } else {
          path.style.fill = 'none';
        }
      });
    });
    
    console.log(`🎨 Updated ${headerSVGs.length} SVG icons to white`);
  }

  // Executa imediatamente e também após pequenos delays
  updateSVGColors();
  setTimeout(updateSVGColors, 100);
  setTimeout(updateSVGColors, 500);
  setTimeout(updateSVGColors, 1000);

  // Observer para monitorar mudanças dinâmicas no DOM (como abertura de menus)
  if (headerElement) {
    const observer = new MutationObserver(() => {
      updateSVGColors();
    });
    
    observer.observe(headerElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
    
    console.log('👀 MutationObserver active - watching for DOM changes');
  }

  console.log('🖤 Black Friday theme applied successfully!');
})();